import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog({alert, confirmAction, cancel, onlyConfirmation,buttonText}) {
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
        cancel()
    };
     if (typeof buttonText === "undefined" || buttonText.trim().length === 0)
     {
        {onlyConfirmation ? buttonText = "OK" : buttonText =  "Yes"}
     }
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {alert}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={confirmAction} color="primary"  >
                        {buttonText}
                    </Button>
                    {!onlyConfirmation ? <Button onClick={handleClose} color="primary" autoFocus>
                        Cancel
                    </Button> : null}
                </DialogActions>
            </Dialog>
        </div>
    );
}
